import { Trans } from '@lingui/react/macro';

import AlertBar from '@/design_system/AlertBar';
import IconPackage from '@/icons/Package.svg';
import { canBeCreatedBy, ShipmentWithRelations } from '@/models/shipment';
import { ShipmentMessageTitle } from '@/routes/Shipments/Shipment/components/ShipmentStep/components/ShipmentMessageTitle';
import { useCurrentSession } from '@/services/auth';

const PreparationMessage = ({
  shipment,
  hideIcon,
  className,
}: {
  shipment: ShipmentWithRelations;
  hideIcon?: boolean;
  className?: string;
}) => {
  const { currentSession } = useCurrentSession();

  const canCreateShipment = canBeCreatedBy(shipment, currentSession);

  if (!canCreateShipment) {
    const originName = shipment.originEntity?.name;
    const destinationName = shipment.destinationEntity?.name;

    return (
      <AlertBar
        type="info"
        size="large"
        icon={<IconPackage />}
        hideIcon={hideIcon}
        className={className}
        title={
          <ShipmentMessageTitle shipment={shipment}>
            <Trans id="requests.transit.transit-pending-message.title.wait">
              Waiting for package preparation
            </Trans>
          </ShipmentMessageTitle>
        }
      >
        {!!originName && !!destinationName && (
          <Trans id="requests.transit.transit-pending-message.text-entity-to-entity.wait">
            {originName} is preparing the package for delivery to {destinationName}.
          </Trans>
        )}
        {!!originName && !!shipment.destinationClientId && (
          <Trans id="requests.delivery.delivery-pending-message.text-entity-to-client.wait">
            {originName} is preparing the package for delivery to the client.
          </Trans>
        )}
      </AlertBar>
    );
  }

  return (
    <AlertBar
      type="warning"
      size="large"
      icon={<IconPackage />}
      hideIcon={hideIcon}
      title={
        <ShipmentMessageTitle shipment={shipment}>
          <Trans id="shipment.preparation-message.title">Prepare the package</Trans>
        </ShipmentMessageTitle>
      }
      className={className}
    >
      <p>
        <Trans id="shipment.preparation-message.text">
          Print and place the item tracking sheet of each item added in the package then validate
          the preparation.
        </Trans>
      </p>
    </AlertBar>
  );
};

export default PreparationMessage;
